import { abi as rewardAbi } from "../../contracts/reward/IReward.sol/IReward.json";
import { abi as erc20Abi } from "../../contracts/ERC20Mock.json";
import { Contract, ethers } from "ethers";
import { chainOptions } from "const";

const chainPrc = process.env.REACT_APP_CHAIN_PRC;
export const rewardAddress = process.env.REACT_APP_REWARD_ADDRESS;

const getRewardAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config
    ?.rewardAddress;
};

export async function getTier(id, currency) {
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, provider);
  const data = await contract.tiers(id, currency);
  const rewardTokenDecimals = await getRewardTokenDecimals();
  return {
    seller: +ethers.utils.formatUnits(data.seller, rewardTokenDecimals),
    buyer: +ethers.utils.formatUnits(data.buyer, rewardTokenDecimals),
    collectionOwner: +ethers.utils.formatUnits(
      data.collectionOwner,
      rewardTokenDecimals
    ),
    id: id,
  };
}

export async function setTokenReward(address) {
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, provider);
  return await contract.setRewardToken(address);
}

export async function rewardToken() {
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, provider);
  return await contract.rewardToken();
}

export async function getRewardToken() {
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, provider);
  return await contract.rewardToken();
}

export async function setTier(
  signer,
  id,
  currency,
  { seller, buyer, collectionOwner }
) {
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, signer);
  const rewardTokenDecimals = await getRewardTokenDecimals();

  const tx = await contract.setTier(id, currency, {
    seller: ethers.utils.parseUnits(seller.toString(), rewardTokenDecimals),
    buyer: ethers.utils.parseUnits(buyer.toString(), rewardTokenDecimals),
    collectionOwner: ethers.utils.parseUnits(
      collectionOwner.toString(),
      rewardTokenDecimals
    ),
  });
  return tx.wait();
}

export async function getTokenInfo(address) {
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const contract = new Contract(address, erc20Abi, provider);

  return {
    name: await contract.name(),
    symbol: await contract.symbol(),
    decimal: await contract.decimals(),
  };
}

export async function getRewardTokenDecimals() {
  const rewardToken = await getRewardToken();
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const contract = new Contract(rewardToken, erc20Abi, provider);
  const decimals = await contract.decimals();
  return decimals;
}

export async function getRewardTokenName() {
  const rewardToken = await getRewardToken();
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const contract = new Contract(rewardToken, erc20Abi, provider);
  const name = await contract.name();
  return name;
}

export async function getCurrentBalance() {
  const rewardToken = await getRewardToken();
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const contract = new Contract(rewardToken, erc20Abi, provider);
  const rewardAddress = await getRewardAddress();
  const balance = await contract.balanceOf(rewardAddress);
  const decimals = await contract.decimals();
  return ethers.utils.formatUnits(balance, decimals);
}

export async function getTotalRewardNeed() {
  const provider = new ethers.providers.JsonRpcProvider(chainPrc);
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, provider);
  const data = await contract.totalBalance();
  const rewardTokenDecimals = await getRewardTokenDecimals();
  return ethers.utils.formatUnits(data, rewardTokenDecimals);
}

export async function setCollectionToPayee(signer, collection, payee) {
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, signer);
  const tx = await contract.setCollectionToPayee(collection, payee);
  return tx.wait();
}

export async function setCollectionToTier(signer, collection, tier) {
  const rewardAddress = await getRewardAddress();
  const contract = new Contract(rewardAddress, rewardAbi, signer);
  const tx = await contract.setCollectionToTier(collection, tier);
  return tx.wait();
}
